import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ServicemenProfile from "../components/ServicemenProfile";

const ServiceProfilePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Servicemen Profile' />

                <ServicemenProfile />

            </MasterLayout>
        </>
    );
};

export default ServiceProfilePage;
